import { Networker } from '@idp/networker';
import { logToSplunk } from './logService';
var interceptor = {
    response: function (url, response) {
        response.then(function (res) {
            if (res.status >= 400) {
                // if api fails report to splunk
                var message = { data: 'url' + url + 'failed with response ' + res };
                logToSplunk(message);
            }
        });
        return response;
    },
};
var networker = new Networker(interceptor);
var loginPageUrl = 'https://www.att.com/my/#/login';
function rejectHTTPErrors(res) {
    if (res.status === 401) {
        window.location.href = loginPageUrl;
        return Promise.reject(res);
    }
    else if (res.status > 401) {
        return Promise.reject(res);
    }
    else {
        return Promise.resolve(res);
    }
}
function parseJSON(res) {
    return res.json();
}
export { networker, rejectHTTPErrors, parseJSON };
//# sourceMappingURL=networker.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idse/core/services/networker.js
// module id = 563
// module chunks = 8